module.exports = __webpack_public_path__ + "static/media/invite-green.c967fc6d.svg";